import { Protection } from "../protections";

export interface ReportSlice {
  time: number;
  value: number;
}

export type ReportData = ReportSlice[];

export interface DrilldownSlice {
  time: number;
  value: {
    categories: string[];
    count: number;
    "device-id": string;
    "first-occurrence": number;
    "group-name": string;
    protocol: string;
    reason: Protection;
    rendered: boolean;
    url: string;
  }[];
}

export interface DrilldownsCsv {
  fileName: string;
  content: string;
}

export type DrilldownData = DrilldownSlice[];

export enum Durations {
  Day = "P1D",
  Week = "P7D",
  Month = "P30D",
}

export type duration = Durations.Day | Durations.Week | Durations.Month;

export type GetReportArgs = [
  endpoint: string,
  subscriberId: string,
  duration: Durations,
  profileName?: string,
  limit?: number,
  adjustGranularity?: boolean
];
